import React from 'react'
import './Maintanance.scss'
import { Link } from 'react-router-dom'
const Maintanence = () => {
  return (
    <div class="container">
      <div class="box">
        <div class="animation">
          <div class="one spin-one"></div>
          <div class="two spin-two"></div>
          <div class="three spin-one"></div>
        </div>
        <h1>This site is under maintenance.</h1>
        <p>Update in progress.</p>
        <h3>
          Please
          <Link to="/">
            <button
              className="btn btn-danger"
              style={{ padding: '5px', textAlign: 'center' }}
            >
              Go back
            </button>
          </Link>
          to main website.
        </h3>
      </div>
    </div>
  )
}

export default Maintanence
